import React from 'react'
import styled from 'styled-components'

import { colors, breakpoints, typography } from "../styles"

const Big = styled.span`
  font-family: SN NeoNoire Subset, Georgia;
  text-shadow: 0.05em 0.05em 0 ${colors.textShadow};
  text-transform: uppercase;
  font-weight: 900;
  color: ${colors.pinkText};
`

const Tight = styled.span`
  letter-spacing: -0.02em;
`

const Small = styled.span`
  color: white;
  text-transform: uppercase;
  ${typography.light}
  letter-spacing: 0.4em;
  ${breakpoints.phone`
    font-weight: 500;
  `}
`

export const FrontEnd = props => (
  <Big {...props}>Front E<Tight>nd</Tight></Big>
)
export const Center = props => (
  <Small {...props}>Center</Small>
)
Center.styledComponentId = Small.styledComponentId



/** WEBPACK FOOTER **
 ** ./src/components/Title.js
 **/